import { showStatus } from './AxiosReqs';

export const deleteProduct = async function (productId) {
  try {
    const res = await axios({
      method: 'DELETE',
      url: `/api/v1/products/delete-product/${productId}`,
      withCredentials: true,
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Product Deleted!');
      window.setTimeout(window.location.reload(), 1500);
    }
  } catch (error) {
    showStatus('fail', 'Failed to delete');
  }
};

const fetchFillForm = async function (id, slug) {
  try {
    const res = await axios({
      method: 'GET',
      url: `/api/v1/products/${slug}`,
    });
    const product = res.data.data.product;

    // # selectors
    const updateForm = document.querySelector('.update-form');

    const nameInput = updateForm.querySelector('input[name="name"]');
    const descriptionInput = updateForm.querySelector(
      'textarea[name="description"]'
    );
    const originalPriceInput = updateForm.querySelector(
      'input[name="originalPrice"]'
    );
    const discountedPriceInput = updateForm.querySelector(
      'input[name="discountedPrice"]'
    );
    const categoryInput = updateForm.querySelector('input[name="category"]');
    const subCategoryInput = updateForm.querySelector(
      'input[name="subCategory"]'
    );

    // assigning vals
    nameInput.value = product.name;
    descriptionInput.value = product.description;
    originalPriceInput.value = product.originalPrice;
    discountedPriceInput.value = product.discountedPrice;
    categoryInput.value = product.category;
    subCategoryInput.value = product.subCategory;

    // * FORM SUBMISSION
    const updateBtn = updateForm.querySelector('button');
    updateBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        const res = await axios({
          method: 'PATCH',
          url: `/api/v1/products/update-product/${id}`,
          data: {
            name: nameInput.value,
            description: descriptionInput.value,
            originalPrice: Number(originalPriceInput.value),
            discountedPrice: Number(discountedPriceInput.value),
            category: categoryInput.value,
            subCategory: subCategoryInput.value,
          },
        });
        if (res.data.status === 'success') {
          showStatus('success', 'Updated Successfully!');
          window.setTimeout(window.location.reload(), 1500);
        }
      } catch (error) {
        showStatus('fail', 'Failed to Update Product');
      }
    });
  } catch (error) {
    showStatus('fail', 'Failed to Update Product');
  }
};

export const updateProductFormOpen = async function (productId, slug) {
  try {
    await fetchFillForm(productId, slug);
  } catch (error) {
    showStatus('fail', 'Failed to load product');
    return;
  }

  const updateForm = document.querySelector('.update-form');

  updateForm.style.display = 'flex';

  const tl = gsap.timeline({ paused: true });
  tl.fromTo(
    updateForm,
    { x: '-100%', opacity: 0 },
    { x: '0%', opacity: 1, duration: 0.5, ease: 'power3.out' }
  );

  tl.play();

  const closeBtn = document.getElementById('close-up-form');

  tl.eventCallback('onReverseComplete', () => {
    updateForm.style.display = 'none';
    tl.pause(0); // reset to start
  });

  closeBtn.onclick = () => {
    tl.reverse();
  };
};
